import React, {useState} from "react";
import * as AuthActions from "@commons/actions/authentication.action";
import SignInCard3 from "./SignInCard3";
import PasswordDimenticata from "./PasswordDimenticata";
import Marquee from "react-fast-marquee";

type LoginState = 'LOGIN' | 'PASSWORD_DIMENTICATA';
const Login: React.FC = () => {
    const [loginState, setLoginState] = useState<LoginState>('LOGIN');
    const onHandlePasswordDimenticata = () => setLoginState('PASSWORD_DIMENTICATA');
    const onHandleTornaAllaLogin = () => setLoginState('LOGIN');
    return <>
        <div className="h-full flex flex-col items-center">

            <div className="grow px-3 w-full md:w-1/2 flex flex-col justify-center">
                {loginState === 'LOGIN' && <SignInCard3 loginAction={AuthActions.login} onHandlePasswordDimenticata={onHandlePasswordDimenticata}/>}
                {loginState === 'PASSWORD_DIMENTICATA' && <PasswordDimenticata onHandleTornaAllaLogin={onHandleTornaAllaLogin}/>}
            </div>
            <div className="self-end w-full bg-white text-black h-10">
                {/*https://www.npmjs.com/package/react-fast-marquee*/}
                <Marquee speed={100} className="h-full">
                    <div className="flex flex-row gap-x-6 items-center md:text-2xl font-bold">
                        <span className="opacity-70 even:opacity-40">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;FPNet.<i className="text-red-700">HR Edition</i></span>
                        {/*<span className="opacity-70 even:opacity-40">Versione BETA</span>*/}
                        <span className="opacity-70 even:opacity-40">Per ulteriori informazioni contatta ERICED srl STP</span>
                        <span className="opacity-70 even:opacity-40">FPNet.<i className="text-red-700">HR Edition</i></span>
                        {/*<span className="opacity-70 even:opacity-40">Versione BETA</span>*/}
                        <span className="opacity-70 even:opacity-40">Puoi accedere con il tuo account FPNet</span>
                    </div>
                </Marquee>
            </div>

        </div>
    </>
}
export default Login;